// Formatting helpers — display only, never fed back into the engine.

/** "$1,234" / "-$1,234.56" (cents shown only when |x| < 100). */
export function money(x: number, cents = false): string {
  const sign = x < 0 ? '-' : '';
  const a = Math.abs(x);
  const opts: Intl.NumberFormatOptions =
    cents || a < 100
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { maximumFractionDigits: 0 };
  return `${sign}$${a.toLocaleString('en-US', opts)}`;
}

/** Signed money delta: "+$164" / "−$23". */
export function moneyDelta(x: number): string {
  return `${x >= 0 ? '+' : '−'}${money(Math.abs(x))}`;
}

/** Age like "18y 4m" from a decimal age (whole substeps → exact months). */
export function ageLabel(age: number): string {
  const months = Math.round(age * 12);
  const y = Math.floor(months / 12);
  const m = months % 12;
  return m === 0 ? `${y}y` : `${y}y ${m}m`;
}
